!function (e, a) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = a() : "function" == typeof define && define.amd ? define(a) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.hsb = a());
}(this, function () {
  "use strict";

  return [{
    locale: "hsb",
    pluralRuleFunction: function (e, a) {
      var t = String(e).split("."),
        o = t[0],
        d = t[1] || "",
        i = !t[1],
        n = o.slice(-2),
        m = d.slice(-2);
      return a ? "other" : i && 1 == n || 1 == m ? "one" : i && 2 == n || 2 == m ? "two" : i && (3 == n || 4 == n) || 3 == m || 4 == m ? "few" : "other";
    },
    fields: {
      year: {
        displayName: "lěto",
        relative: {
          0: "lětsa",
          1: "klětu",
          "-1": "loni"
        },
        relativeTime: {
          future: {
            one: "za {0} lěto",
            two: "za {0} lěće",
            few: "za {0} lěta",
            other: "za {0} lět"
          },
          past: {
            one: "před {0} lětom",
            two: "před {0} lětomaj",
            few: "před {0} lětami",
            other: "před {0} lětami"
          }
        }
      },
      "year-short": {
        displayName: "l.",
        relative: {
          0: "lětsa",
          1: "klětu",
          "-1": "loni"
        },
        relativeTime: {
          future: {
            one: "za {0} l.",
            two: "za {0} l.",
            few: "za {0} l.",
            other: "za {0} l."
          },
          past: {
            one: "před {0} l.",
            two: "před {0} l.",
            few: "před {0} l.",
            other: "před {0} l."
          }
        }
      },
      month: {
        displayName: "měsac",
        relative: {
          0: "tutón měsac",
          1: "přichodny měsac",
          "-1": "zašły měsac"
        },
        relativeTime: {
          future: {
            one: "za {0} měsac",
            two: "za {0} měsacaj",
            few: "za {0} měsacy",
            other: "za {0} měsacow"
          },
          past: {
            one: "před {0} měsacom",
            two: "před {0} měsacomaj",
            few: "před {0} měsacami",
            other: "před {0} měsacami"
          }
        }
      },
      "month-short": {
        displayName: "měs.",
        relative: {
          0: "tutón měsac",
          1: "přichodny měsac",
          "-1": "zašły měsac"
        },
        relativeTime: {
          future: {
            one: "za {0} měs.",
            two: "za {0} měs.",
            few: "za {0} měs.",
            other: "za {0} měs."
          },
          past: {
            one: "před {0} měs.",
            two: "před {0} měs.",
            few: "před {0} měs.",
            other: "před {0} měs."
          }
        }
      },
      day: {
        displayName: "dźeń",
        relative: {
          0: "dźensa",
          1: "jutře",
          "-1": "wčera"
        },
        relativeTime: {
          future: {
            one: "za {0} dźeń",
            two: "za {0} dnjej",
            few: "za {0} dny",
            other: "za {0} dnjow"
          },
          past: {
            one: "před {0} dnjom",
            two: "před {0} dnjomaj",
            few: "před {0} dnjemi",
            other: "před {0} dnjemi"
          }
        }
      },
      "day-short": {
        displayName: "dźeń",
        relative: {
          0: "dźensa",
          1: "jutře",
          "-1": "wčera"
        },
        relativeTime: {
          future: {
            one: "za {0} dźeń",
            two: "za {0} dnj.",
            few: "za {0} dny",
            other: "za {0} dnj."
          },
          past: {
            one: "před {0} dnj.",
            two: "před {0} dnj.",
            few: "před {0} dnj.",
            other: "před {0} dnj."
          }
        }
      },
      hour: {
        displayName: "hodźina",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            one: "za {0} hodźinu",
            two: "za {0} hodźinje",
            few: "za {0} hodźiny",
            other: "za {0} hodźin"
          },
          past: {
            one: "před {0} hodźinu",
            two: "před {0} hodźinomaj",
            few: "před {0} hodźinami",
            other: "před {0} hodźinami"
          }
        }
      },
      "hour-short": {
        displayName: "hodź.",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            one: "za {0} hodź.",
            two: "za {0} hodź.",
            few: "za {0} hodź.",
            other: "za {0} hodź."
          },
          past: {
            one: "před {0} hodź.",
            two: "před {0} hodź.",
            few: "před {0} hodź.",
            other: "před {0} hodź."
          }
        }
      },
      minute: {
        displayName: "minuta",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            one: "za {0} minutu",
            two: "za {0} minuće",
            few: "za {0} minuty",
            other: "za {0} minutow"
          },
          past: {
            one: "před {0} minutu",
            two: "před {0} minutomaj",
            few: "před {0} minutami",
            other: "před {0} minutami"
          }
        }
      },
      "minute-short": {
        displayName: "min.",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            one: "za {0} min.",
            two: "za {0} min.",
            few: "za {0} min.",
            other: "za {0} min."
          },
          past: {
            one: "před {0} min.",
            two: "před {0} min.",
            few: "před {0} min.",
            other: "před {0} min."
          }
        }
      },
      second: {
        displayName: "sekunda",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            one: "za {0} sekundu",
            two: "za {0} sekundźe",
            few: "za {0} sekundy",
            other: "za {0} sekundow"
          },
          past: {
            one: "před {0} sekundu",
            two: "před {0} sekundomaj",
            few: "před {0} sekundami",
            other: "před {0} sekundami"
          }
        }
      },
      "second-short": {
        displayName: "sek.",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            one: "za {0} sek.",
            two: "za {0} sek.",
            few: "za {0} sek.",
            other: "za {0} sek."
          },
          past: {
            one: "před {0} sek.",
            two: "před {0} sek.",
            few: "před {0} sek.",
            other: "před {0} sek."
          }
        }
      }
    }
  }];
});